module.exports = __webpack_public_path__ + "media/48.bf6347aa.mp3";